import { SecretValue } from "client/Api/Apps/common";
import { environmentHttpClient as httpClient } from "client/Api/httpClient";

export type ZaaksysteemConnectionModel = {
	id: number;
	name: string;
	serverUrl: string;
	apiInterfaceId: number;
};

export type ZaaksysteemConnectionListItemModel = {
	id: number;
	name: string;
	serverUrl: string;
};

export type ZaaksysteemConnectionSaveModel = {
	name: string;
	serverUrl: string;
	apiInterfaceId: number | null;
	apiKey: SecretValue;
};

export type NewConnectionZaaksysteemSaveResultModel = {
	connectionId: number;
};

export function list(
	signal?: AbortSignal
): Promise<ReadonlyArray<ZaaksysteemConnectionListItemModel>> {
	return httpClient.get<ReadonlyArray<ZaaksysteemConnectionListItemModel>>(
		"UiApi/ZaaksysteemConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal?: AbortSignal
): Promise<ZaaksysteemConnectionModel> {
	return httpClient.get<ZaaksysteemConnectionModel>(
		`UiApi/ZaaksysteemConfiguration/${id}`,
		undefined,
		{ signal }
	);
}

export function create(
	model: ZaaksysteemConnectionSaveModel,
	signal?: AbortSignal
): Promise<NewConnectionZaaksysteemSaveResultModel> {
	return httpClient.post<NewConnectionZaaksysteemSaveResultModel>(
		"UiApi/ZaaksysteemConfiguration",
		model,
		{ signal }
	);
}

export function update(
	id: number,
	model: ZaaksysteemConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return httpClient.put<void>(
		`UiApi/ZaaksysteemConfiguration/${id}`,
		model,
		{ signal }
	);
}

export function deleteMultiple(
	ids: ReadonlyArray<number>,
	signal?: AbortSignal
): Promise<void> {
	return httpClient.delete<void>(
		"UiApi/ZaaksysteemConfiguration",
		ids,
		{ signal }
	);
}
